module.exports = __webpack_public_path__ + "img/202501_01_sp.fb00f3e5.jpg";